import { Directionality } from "@angular/cdk/bidi";
import { ViewportRuler } from "@angular/cdk/overlay";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  Optional,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { NzResizeObserver } from "ng-zorro-antd/cdk/resize-observer";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { ɵNzTabNavBarComponent } from "ng-zorro-antd/tabs";
import { UiTabNavItemDirective } from "../../directives/tab-nav-item.directive";
import { UiTabsInkBarDirective } from "../../directives/tabs-ink-bar.directive";
import { UiTabPositionMode, UiTabScrollEvent } from "../../models/tab.models";
import { UiTabAddButtonComponent } from "../tab-add-button/tab-add-button.component";
import { UiTabNavOperationComponent } from "../tab-nav-operation/tab-nav-operation.component";

@Component({
  selector: "ui-tabs-nav",
  exportAs: "uiTabsNav",
  templateUrl: "./tab-nav-bar.component.html",
  styleUrls: ["tab-nav-bar.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: "ui-tabs-nav",
  },
})
export class UiTabNavBarComponent extends ɵNzTabNavBarComponent {
  @Output() public readonly indexFocused: EventEmitter<number> = new EventEmitter<number>();
  @Output() public readonly selectFocusedIndex: EventEmitter<number> = new EventEmitter<number>();
  @Output() public readonly addClicked = new EventEmitter<void>();
  @Output() public readonly tabScroll = new EventEmitter<UiTabScrollEvent>();

  @Input() public position: UiTabPositionMode = "horizontal";
  @Input() public addable = false;
  @Input() public hideBar = false;
  @Input() public addIcon: string | TemplateRef<NzSafeAny> = "plus";
  @Input() public inkBarAnimated = true;
  @Input() public extraTemplate?: TemplateRef<void>;

  @Input("uiSelectedIndex")
  get uiSelectedIndex(): number {
    return this.selectedIndex;
  }
  set uiSelectedIndex(value: number) {
    this.selectedIndex = value;
  }

  @ViewChild("navWarp", { static: true }) public navWarpRef!: ElementRef<HTMLElement>;
  @ViewChild("navList", { static: true }) public navListRef!: ElementRef<HTMLElement>;
  @ViewChild(UiTabNavOperationComponent, { static: true }) public operationRef!: UiTabNavOperationComponent;
  @ViewChild(UiTabAddButtonComponent, { static: false }) public addBtnRef!: UiTabAddButtonComponent;
  @ViewChild(UiTabsInkBarDirective, { static: true }) public inkBar!: UiTabsInkBarDirective;
  @ContentChildren(UiTabNavItemDirective, { descendants: true }) public items!: QueryList<UiTabNavItemDirective>;

  constructor(cdr: ChangeDetectorRef, ngZone: NgZone, viewportRuler: ViewportRuler, uiResizeObserver: NzResizeObserver, @Optional() dir: Directionality) {
    super(cdr, ngZone, viewportRuler, uiResizeObserver, dir);
  }

  public hiddenItems: UiTabNavItemDirective[];
}
